<template>
  <div class="p-8">
    <div class="flex">
      <div class="flex-1">
        <TextArea
          :id="id"
          :labelName="labelName"
          :value="value"
          :disabled="disabled || loading"
          :preventEnterDefault="true"
          propClasses="min-h-[96px] !pr-[64px]"
          :rows="3"
          @enter="onEnter"
          @input="$emit('input', $event)"
        />
      </div>
      <Button
        v-if="trimmedValue"
        class="!absolute bottom-[14px] right-[14px]"
        :value="sendLabel"
        size="small"
        variant="primary"
        :disabled="disabled || loading || !trimmedValue"
        :loading="loading"
        @click="$emit('send')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import TextArea from '@/components/textarea/TextArea.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'MessageComposer',
  components: {
    TextArea,
    Button,
  },
  props: {
    id: {
      type: String,
      default: 'message-composer',
    },
    labelName: {
      type: String,
      default: 'Message',
    },
    value: {
      type: String,
      default: '',
    },
    sendLabel: {
      type: String,
      default: 'Send',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    trimmedValue(): string {
      return this.value.trim();
    },
  },
  methods: {
    onEnter() {
      if (this.trimmedValue) this.$emit('send');
    },
  },
};
</script>
